import {
  useAuthStore, useSettingStore,
} from '../'
import {
  useRoute,
} from '#imports'

export const ENDPOINT_URL = import.meta.env.VITE_APP_API_URL
export function getHeaders() {
  const {
    token,
  } = useAuthStore()
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token.replace(/Bearer /g, '')}`,
  }
}

export function getQuery() {
  const {
    hotelId,
  } = useAuthStore()
  const {
    lang_id,
  } = useSettingStore()
  const id = Number(hotelId)
  return {
    hotel_id: id,
    lang_id,
  }
}

export function getDataLang(val: any, lang_id?: number, scope?: string) {
  let data = val
  const { languages } = useSettingStore()
  const route = useRoute()
  let iso_code = ''
  if (val && typeof val === 'object' && !Array.isArray(val)) {
    let tmpLanguages: any = []
    if (languages && languages.length) {
      tmpLanguages = languages.filter((el: any) => (lang_id
        && Number(el?.label_id) === Number(lang_id)) || el?.label_uri === route?.params?.language)
      if (tmpLanguages && tmpLanguages.length)
        iso_code = tmpLanguages[0]?.iso_code
    }

    if (scope && val[scope] && val[scope][iso_code])
      data[scope] = val[scope][iso_code]
    else if (val[iso_code])
      data = val[iso_code]
  }
  return data
}
